/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Engagement_Today_FirstInputs */

const en_us2_engagement_today_first = /** @type {(inputs: Engagement_Today_FirstInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your first workout is ready. Go at your own pace: the plan adjusts to you.`)
};

const pt_br2_engagement_today_first = /** @type {(inputs: Engagement_Today_FirstInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seu primeiro treino está pronto. Vá no seu ritmo: o plano se ajusta a você.`)
};

const es_419_engagement_today_first = /** @type {(inputs: Engagement_Today_FirstInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tu primer entrenamiento está listo. Ve a tu ritmo: el plan se ajusta a ti.`)
};

const pt_pt2_engagement_today_first = /** @type {(inputs: Engagement_Today_FirstInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O teu primeiro treino está pronto. Vai ao teu ritmo: o plano ajusta-se a ti.`)
};

const fr_fr2_engagement_today_first = /** @type {(inputs: Engagement_Today_FirstInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ta première séance est prête. Va à ton rythme : le programme s'adapte à toi.`)
};

const de_de2_engagement_today_first = /** @type {(inputs: Engagement_Today_FirstInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dein erstes Training ist bereit. Geh es in deinem Tempo an: Der Plan passt sich dir an.`)
};

const it_it2_engagement_today_first = /** @type {(inputs: Engagement_Today_FirstInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Il tuo primo allenamento è pronto. Vai al tuo ritmo: la scheda si adatta a te.`)
};

/**
* | output |
* | --- |
* | "Your first workout is ready. Go at your own pace: the plan adjusts to you." |
*
* @param {Engagement_Today_FirstInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const engagement_today_first = /** @type {((inputs?: Engagement_Today_FirstInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Engagement_Today_FirstInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_engagement_today_first(inputs)
	if (locale === "es-419") return es_419_engagement_today_first(inputs)
	if (locale === "pt-PT") return pt_pt2_engagement_today_first(inputs)
	if (locale === "fr-FR") return fr_fr2_engagement_today_first(inputs)
	if (locale === "de-DE") return de_de2_engagement_today_first(inputs)
	if (locale === "it-IT") return it_it2_engagement_today_first(inputs)
	return en_us2_engagement_today_first(inputs)
});
export { engagement_today_first as "engagement.today_first" }